import loader from '../moduleLoader';
import './toggle.css';

function Toggle(toggle) {

  var trigger;
  var close;
  var area;
  var id;
  var toggleGroup;

  function init() {
    trigger = toggle.querySelector('.toggle__control');
    close = toggle.querySelectorAll('.toggle__close');
    area = toggle.querySelector('.toggle__area');    
    id = '_' + Math.random().toString(36).substr(2, 9);
    toggleGroup = toggle.dataset.toggleGroup;

    if(toggle.dataset.maxMedia) {
      var media = window.matchMedia(`(max-width: ${toggle.dataset.maxMedia}px)`);
      handleMatchMedia(media);
      media.addListener(handleMatchMedia);
    }
    else {
      load();
    }
  }

  function handleMatchMedia(e) {
    e.matches ? load() : unload();
  }

  function load() {
    toggle.setAttribute('data-toggle-expanded', 'false')
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-controls', id);
    area.setAttribute('id', id);
    trigger.addEventListener('click', handleTriggerClick);
    document.addEventListener("ToggleCollapseGroup", collapse);
  }

  function unload() {
    toggle.setAttribute('data-toggle-expanded', true);
    trigger.removeAttribute('aria-expanded', 'false');
    trigger.removeAttribute('aria-controls');
    area.removeAttribute('id');
    trigger.removeEventListener('click', handleTriggerClick); 
    document.removeEventListener("ToggleCollapseGroup", handleCollapseGroup); 
  }

  function handleTriggerClick(e) {
    e.preventDefault();
    var isExpanded = trigger.getAttribute('aria-expanded') === 'true';
    isExpanded ? collapse() : expand();
  }

  function handleCollapseGroup(e) {
    collapse(true);
  }

  function expand() {
    if(toggleGroup) {
      var event = new CustomEvent("ToggleCollapseGroup");
      document.dispatchEvent(event);
    }
    trigger.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('data-toggle-expanded', 'true');
    if(close) {
      Array.from(close).forEach((button) => {
        button.addEventListener('click', collapse);
      })
    }
  }

  function collapse(expanding) {
    trigger.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('data-toggle-expanded', 'false');
    if(close) {
      Array.from(close).forEach((button) => {
        button.removeEventListener('click', collapse);
      }) 
    }

    if(!expanding && toggleGroup) {
      var event = new CustomEvent("AllCollapsed", area);
      document.dispatchEvent(event);
    }
  }

  return {
    init: init
  }
}

loader.add('Toggle', Toggle);

export default Toggle;
